import { render } from "./EmbedScriptsList.vue?vue&type=template&id=264ed53a&scoped=true"
import script from "./EmbedScriptsList.vue?vue&type=script&lang=js"
export * from "./EmbedScriptsList.vue?vue&type=script&lang=js"

import "./EmbedScriptsList.vue?vue&type=style&index=0&id=264ed53a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264ed53a"]])

export default __exports__